import { Separator } from "@app/components/core/Separator/Separator"
import { addThermencardLine, deleteOrderLine } from "@app/store/actions/orderActions"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import OrderLine from "../OrderLine/OrderLine"
import OrderLines from "../OrderLines/OrderLines"

const getThermencardLines = formattedOrder => {
	const lines = []
	formattedOrder.orderLines.forEach(orderLine => {
		if (!orderLine) return
		let details = orderLine.details.filter(detail => detail.typeId === ORDER_LINE_TYPES.Account)
		if (details.length > 0) {
			lines.push({
				...orderLine,
				details,
			})
		}
	})

	return JSON.parse(JSON.stringify(lines))
}

export default function Thermencard({ formattedOrder, isEditable, onAction }) {
	const productLines = getThermencardLines(formattedOrder)

	if (productLines.length) {
		return (
			<div className="mt-4">
				<h2 id="order-overview-thermencard-title" className="f4 regular">
					Thermencard
				</h2>
				<Separator />
				<OrderLines ariaLabelledBy="order-overview-thermencard-title">
					{productLines.map((product, index) => {
						return (
							<OrderLine
								key={index}
								orderLine={product}
								isEditable={isEditable}
								showMinus
								onMinus={() => {
									deleteOrderLine(product, 1)
									onAction()
								}}
								onPlus={() => {
									addThermencardLine(product)
									onAction()
								}}
							/>
						)
					})}
				</OrderLines>
			</div>
		)
	}
}
